<template>
  <v-tabs-items :value="value" @input="handleInput">
    <slot />
  </v-tabs-items>
</template>

<script>
export default {
  name: "TabItems",
  props: {
    value: {
      type: Number
    }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped>

</style>